// Importar axios
import axios from "axios";
import settings from "./settings";

// Crear instancia
const apiClient = axios.create({
  baseURL: settings.baseUrl
});

// Configurar auth token en los headers globales
const token = localStorage.getItem("auth-token");
apiClient.defaults.headers.common = {};

if (token) {
  apiClient.defaults.headers.common["auth-token"] = token;
}

export default apiClient;
